module.exports = __webpack_public_path__ + "img/gb1235-76-22.prt.7dc40b39.jpg";